import { Config } from "@/shared/config";

const cardServiceUri = Config.CardServicebaseUri;

export default {
  get cardV1 () {
    return `${cardServiceUri}/card/v1`;
  },
  fiservDebitCards () {
    return `${this.cardV1}/list`;
  },
  setFiservDebitCardPIN (fiservUserInfoId: number): string {
    return `${this.cardV1}/pin/${fiservUserInfoId}`;
  },
  deativateFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/cancel/${fiservUserInfoId}`;
  },
  replaceFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/replace/${fiservUserInfoId}`;
  },
  confirmReplacementFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/confirm-replacement/${fiservUserInfoId}`;
  },
  addFiservDebitCardDependent (): string {
    return `${this.cardV1}/dependent/`;
  },
  partnerCardIssueCriterias (partnerId: number): string {
    return `${this.cardV1}/issue-criterias/partner/${partnerId}`;
  },
  deleteCardIssueCriterias (id: number): string {
    return `${this.cardV1}/issue-criterias/${id}`;
  },
  createCardIssueCriteria (): string {
    return `${this.cardV1}/issue-criterias`;
  }
};